import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setTraineePositionById, setTraineeTasksError } from "../../repository/slice";

function* getTraineePositionByIdWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<{ count: number, rows: any[] }> = yield call(requester.get, "/api/dynamic-destination/intern/" + payload.id);
        if (isError) {
            yield put(setTraineeTasksError(message));
        } else {            
            yield put(setTraineeTasksError(null));
            yield put(setTraineePositionById(data));
        }
    } catch (error) {
        console.error("getTraineePositionByIdWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getTraineePositionByIdWatcher() {
    yield takeLatest("@saga/GET_TRAINEE_POSITION_BY_ID", getTraineePositionByIdWorker);
};